export const state = () => ({
	users: [],
	user_tabs: [true, false],
});
export const mutations = {
	setUsers(state: any, payload: any) {
		state.users = payload;
	},

	setUserTab(state: any, payload: any) {
		state.user_tabs = payload;
	},
};
export const getters = {
	getUsers: (state: any) => state.users,
	getUserTab: (state: any) => state.user_tabs,
};
export const actions = {
	async getUsers(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/company/' + payload + '/users')
				.then((res) => {
					state.commit('setUsers', res.data);

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateUser(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + payload.company_uuid + '/users/' + payload.user_uuid, { params: payload.params })
				.then((res) => {
					state.commit('setUsers', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateUserTab(state: any, payload: any) {
		state.commit('setUserTab', payload);
	},
};
